import { Divider, Row } from "antd";
import React from "react";

const filePath = `${window.location.origin}/`;

class Gdpr extends React.Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <Divider>GDPR</Divider>
        <Row>
          <a href={`${filePath}/gdpr.pdf`}>gdpr.pdf</a>
        </Row>
      </React.Fragment>
    );
  }
}

export default Gdpr;
